import { configureStore } from "@reduxjs/toolkit";
import {combineReducers} from "redux"; 
import {
    persistStore,
    persistCombineReducers,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import  {SPAJSlice,SPAJDetailSlice}  from './features/SPAJSlice';
import ParameterReducer from './features/OTPSlice';
import Ilustration from './features/IllustrationSPAJSlice';
import {ilustrationSignature, Selfie, Video} from './features/CameraAndSignatureSlice'
import { DeviceId,CitySign } from '../store/features/OTPSlice'

const reducer = combineReducers({
    SPAJs: SPAJSlice.reducer,
    SPAJsDetail:SPAJDetailSlice.reducer,
    Params: ParameterReducer,
    Ilustration: Ilustration,
    Signature:ilustrationSignature.reducer,
    Selfie: Selfie.reducer,
    DeviceId: DeviceId.reducer,
    Video: Video.reducer,
    CitySign: CitySign.reducer
})

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
  }
const persistedReducer = persistReducer(persistConfig, reducer)


export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  })